export const aboutHeroData = {
  image: "https://readdy.ai/api/search-image?query=Abstract%20organic%20flowing%20shapes%20in%20warm%20beige%20cream%20and%20soft%20terracotta%20orange%20tones%2C%20gentle%20gradient%20curves%20and%20overlapping%20translucent%20layers%2C%20minimalist%20Japanese%20aesthetic%20with%20quiet%20elegance%2C%20soft%20diffused%20lighting%20creating%20subtle%20depth%2C%20no%20people%20no%20faces%20no%20text%2C%20serene%20calm%20atmosphere%20with%20fluid%20organic%20movement%2C%20warm%20harmonious%20palette%20with%20sandy%20and%20clay%20hues&width=1600&height=900&seq=about-hero-v1&orientation=landscape",
  breadcrumbs: [
    { label: "ホーム", href: "/" },
    { label: "私たちについて", href: "" },
  ],
  label: "ABOUT US",
  mainCopy: "つくるだけでなく、\n使われ続けるところまで。",
  description:
    "ノーブルラボは、株式会社ノーブルウェブのDX支援事業部です。約20年にわたるウェブ制作と運営支援の経験を生かし、AIやデジタルを現場で使える仕組みに整えます。",
  ctas: [
    { label: "サービスを見る", href: "/#services", primary: true },
    { label: "DXについて相談する", href: "#contact", primary: false },
  ],
};

export const aboutNavItems = [
  { anchor: "#about-lab", label: "Noble Laboとは" },
  { anchor: "#why-started", label: "事業を始めた理由" },
  { anchor: "#message", label: "代表メッセージ" },
  { anchor: "#our-dx-view", label: "私たちの考えるDX" },
  { anchor: "#principles", label: "大切にしていること" },
  { anchor: "#two-business", label: "二つの事業" },
  { anchor: "#name-meaning", label: "Noble Laboについて" },
  { anchor: "#company", label: "運営会社" },
];

export const aboutLabData = {
  label: "ABOUT NOBLE LABO",
  heading: "中小企業と地域団体の、身近なDX相談相手として",
  paragraphs: [
    "ノーブルラボは、株式会社ノーブルウェブが運営するDX支援事業です。",
    "AI、Google Workspace、ウェブ、業務ツールなどを活用し、中小企業や少人数の団体が抱える業務上の課題を整理します。",
    "大規模なシステム導入を前提にせず、現在の人員、予算、利用環境に合わせて、小さく始められる方法をご提案します。",
  ],
  flowSteps: [
    { label: "話を聞く", icon: "ri-chat-1-line" },
    { label: "業務を整理する", icon: "ri-file-list-3-line" },
    { label: "必要な仕組みを考える", icon: "ri-lightbulb-line" },
    { label: "導入・制作する", icon: "ri-settings-4-line" },
    { label: "実際に使えるまで支援する", icon: "ri-user-heart-line" },
  ],
};

export const whyStartedData = {
  label: "WHY WE STARTED",
  heading: "ウェブ制作の先に、お客様の課題がありました",
  paragraphs: [
    "株式会社ノーブルウェブは、約20年にわたり、ホームページの制作と、公開後の保守・運営を支援してきました。長くお客様と関わる中で、私たちが相談される内容は、ホームページだけではなくなっていきました。",
  ],
  problemQuestions: [
    "誰が更新するのか。",
    "申込や問い合わせをどう受け付けるのか。",
    "会員名簿や資料をどう共有するのか。",
    "担当者が変わっても、業務を続けられるようにするにはどうすればよいのか。",
  ],
  closingParagraphs: [
    "ホームページは、組織の活動を支える仕組みの一つです。",
    "しかし、情報発信だけを整えても、日々の業務や運営そのものが回らなければ、十分とはいえません。そして今、AIやデジタルツールによって、これまで人手や予算の問題で難しかった業務改善を、小さな組織でも現実的に進められるようになりました。",
    "ツールを導入して終わるのではなく、業務を整理し、必要な仕組みをつくり、実際に使い続けられるところまで支援する。そのために立ち上げたのが、ノーブルラボです。",
  ],
  flowSteps: [
    { num: "01", title: "ホームページをつくる", desc: "企業や団体の情報を、必要な人へ届ける基盤をつくる。" },
    { num: "02", title: "公開後の更新・運営を支える", desc: "制作後も、更新、保守、情報発信を継続して支援する。" },
    { num: "03", title: "情報共有や受付業務の相談を受ける", desc: "ファイル共有、申込受付、会員管理、議事録など、運営に関する相談が増える。" },
    { num: "04", title: "AIで改善できる領域が広がる", desc: "これまで人手が必要だった仕事を、AIやデジタルで改善できるようになる。" },
    { num: "05", title: "業務や組織運営まで支援する", desc: "業務を整理し、仕組みをつくり、実際に使い続けられるところまで支援する。" },
  ],
  closingMessage: "相談が増えたから、新しいサービスを加えたのではありません。\nAIによって、これまで解決できなかった運営課題にも、現実的な提案ができるようになった。\nそれが、ノーブルラボを始めた理由です。",
};

export const messageSupportData = {
  label: "MESSAGE",
  heading: "現場で本当に使われる仕組みを、お客様と一緒に",
  name: "株式会社ノーブルウェブ",
  title: "代表取締役　松原伸禎",
  paragraphs: [
    "株式会社ノーブルウェブは、ウェブ制作会社として約20年間、お客様の情報発信とウェブサイトの運営を支援してきました。",
    "長くお客様と関わる中で、人手不足、業務の属人化、情報共有、引き継ぎなど、ホームページだけでは解決できない課題に数多く出会ってきました。",
    "また、私自身も地域団体や会員組織の運営に関わる中で、専任担当者が少ない事務局の負担や、担当者交代時の引き継ぎの難しさを実感してきました。",
    "AIやデジタルには、こうした課題を改善する力があります。ただし、ツールを導入するだけでは、現場の仕事は変わりません。",
    "必要なのは、現在の業務を理解し、その組織に合う使い方を考え、実際に使えるところまで一緒に進めることだと考えています。",
    "Noble Laboは、大きなシステムを売ることを目的とした事業ではありません。",
    "中小企業や地域団体が、無理のない形でAIやデジタルを活用し、活動を続けやすくするための、身近な相談相手を目指します。",
  ],
  supportHeading: "代表の松原が直接ご相談を伺います。",
  supportText:
    "課題整理、DX支援、AI・デジタル活用のご相談は、代表の松原が直接担当します。ウェブ制作、システム開発、保守管理が必要な場合は、株式会社ノーブルウェブの制作体制と連携して対応します。",
  supportSteps: [
    { label: "お客様", icon: "ri-user-3-line" },
    { label: "松原が直接\nヒアリング・課題整理", icon: "ri-chat-check-line" },
    { label: "必要に応じて\nウェブ制作・システム開発・\n保守チームと連携", icon: "ri-team-line" },
  ],
  photoDescription: "代表者ポートレート（後日差し替え予定）",
};

export const ourDXViewData = {
  label: "OUR VIEW OF DX",
  heading: "大規模システムを導入することだけがDXではない",
  paragraph:
    "ノーブルラボでは、DXを「日々の仕事を少し楽にし、特定の人に依存せず、組織が無理なく活動を続けられる状態をつくること」と考えています。",
  points: [
    {
      num: "01",
      title: "仕事を減らす",
      desc: "繰り返し行う作業を見直し、AIやデジタルを使って負担を減らします。",
      icon: "ri-timer-flash-line",
    },
    {
      num: "02",
      title: "情報を共有する",
      desc: "担当者だけが知っている情報を整理し、必要な人が確認できる状態をつくります。",
      icon: "ri-share-line",
    },
    {
      num: "03",
      title: "引き継げるようにする",
      desc: "業務の進め方、判断、アカウント、ファイルの置き場所を記録します。",
      icon: "ri-account-pin-circle-line",
    },
    {
      num: "04",
      title: "使い続けられるようにする",
      desc: "導入して終わらず、実際に使われているか確認し、改善を続けます。",
      icon: "ri-loop-left-line",
    },
  ],
};

export const principlesData = {
  label: "OUR PRINCIPLES",
  heading: "現場に合わない正解を、押し付けない",
  items: [
    {
      title: "現在の状況から始める",
      desc: "理想的な環境を前提にせず、現在の人員、予算、スキル、利用ツールを確認します。",
      icon: "ri-compass-3-line",
    },
    {
      title: "小さく試す",
      desc: "最初から大きな投資をせず、効果を確認しながら改善します。",
      icon: "ri-seedling-line",
    },
    {
      title: "分かる言葉で説明する",
      desc: "専門用語だけで説明せず、何が変わり、誰がどう使うのかを明確にします。",
      icon: "ri-chat-smile-2-line",
    },
    {
      title: "導入して終わらない",
      desc: "設定、制作、研修、運用確認まで、実際に使える状態を目指します。",
      icon: "ri-flag-2-line",
    },
  ],
  highlight:
    "新しいツールを導入すること自体を目的にしません。現在の方法で十分な場合は、そのこともお伝えします。",
};

export const integratedBusinessData = {
  label: "TWO BUSINESS AREAS",
  heading: "ウェブ制作と運営支援の経験を、次の20年へ",
  intro:
    "これまで培ってきたウェブ制作と運営支援を基盤に、業務や組織運営へ支援領域を広げます。",
  web: {
    title: "ウェブ制作事業部",
    subtitle: "情報発信の基盤をつくる",
    items: [
      "ホームページ制作",
      "WordPress構築",
      "ウェブシステム開発",
      "保守管理",
      "更新・運営支援",
    ],
    linkLabel: "ウェブ制作事業部を見る",
    linkHref: "https://www.nobleweb.jp",
  },
  dx: {
    title: "DX支援事業部｜Noble Labo",
    subtitle: "業務と組織運営を支える",
    items: [
      "DX顧問",
      "伴走型AI事務局サポート",
      "AI・デジタル導入支援",
      "業務ツール・システム開発",
    ],
    linkLabel: "DX支援サービスを見る",
    linkHref: "/#services",
  },
  bottomMessage:
    "ウェブ制作とDX支援の両輪で、ノーブルウェブは次の20年へ進みます。",
};

export const nameMeaningData = {
  label: "OUR NAME",
  heading: "Noble Laboに込めた意味",
  paragraphs: [
    "Noble Laboは、株式会社ノーブルウェブが、ウェブの枠を越えて新しい支援方法を研究し、実践する場として立ち上げたブランドです。",
    "Laboという名前には、完成された答えを一方的に提供するのではなく、お客様と一緒に試し、学び、よりよい方法をつくっていくという考えを込めています。",
  ],
  keywords: ["考える", "試す", "つくる", "使う", "改善する"],
};

export const companyData = {
  label: "COMPANY",
  heading: "運営会社",
  rows: [
    { th: "会社名", td: "株式会社ノーブルウェブ" },
    { th: "ブランド名", td: "Noble Labo" },
    { th: "事業部", td: "DX支援事業部" },
    { th: "代表者", td: "代表取締役 松原伸禎" },
    { th: "所在地", td: "東京都杉並区高円寺" },
    {
      th: "事業内容",
      td: "ウェブ制作、ウェブ保守・運営支援、DX支援、AI・デジタル導入支援、業務ツール開発",
    },
  ],
  linkLabel: "株式会社ノーブルウェブについて詳しく見る",
  linkHref: "https://www.nobleweb.jp",
};

export const aboutCtaData = {
  label: "CONTACT",
  heading: "一緒に考えるところから、始めませんか。",
  description:
    "具体的なツールやシステムが決まっていなくても問題ありません。現在の業務や困りごとを伺い、何から始めるべきか一緒に整理します。",
  ctas: [
    { label: "DXについて相談する", href: "#contact", primary: false },
    { label: "サービスを見る", href: "/#services", primary: true },
  ],
  supports: [
    "何も決まっていない段階でも相談可能",
    "代表の松原が直接対応",
    "オンライン・訪問対応",
    "無理なシステム導入を前提にしない",
  ],
  inquiryTypes: [
    "DX顧問について",
    "伴走型AI事務局サポートについて",
    "AI・デジタル導入について",
    "業務ツール・システム開発について",
    "その他",
  ],
};